<template>
  <section>
    <TheHeader
      class="bg-grey-lightest md:bg-white"
      with-menu
    />
    <TheBackgroundHeader>
      <BaseSection class="mb-4">
        <BaseTitleGroup
          :title="$t('My investments')"
        />
      </BaseSection>
    </TheBackgroundHeader>
    <BaseSection class="min-h-half mb-15">
      <BaseList
        v-if="formattedInvestments.length"
        :items="formattedInvestments"
        class="mb-20"
      />
      <BaseEmptyState
        v-else
        :src="barchart"
      >
        Vous n'avez pas encore d'investissement réalisé
      </BaseEmptyState>
    </BaseSection>
    <TheFooter />
  </section>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { orderBy } from 'lodash';

import TheHeader from '../components/TheHeader.vue';
import TheBackgroundHeader from '../components/TheBackgroundHeader.vue';
import BaseSection from '../components/BaseSection.vue';
import BaseTitleGroup from '../components/BaseTitleGroup.vue';
import BaseList from '../components/BaseList.vue';
import BaseEmptyState from '../components/BaseEmptyState.vue';
import TheFooter from '../components/TheFooter.vue';
import barchart from '../assets/barchart.svg';

export default {

  name: 'Investments',
  metaInfo: {
    title: 'Mes investissements',
  },
  components: {
    TheHeader,
    TheBackgroundHeader,
    BaseSection,
    BaseTitleGroup,
    BaseList,
    BaseEmptyState,
    TheFooter,
  },

  data() {
    return { barchart };
  },

  computed: {
    ...mapState('investment', ['list']),
    formattedInvestments() {
      const router = this.$router;
      const result = this.list.map(({
        id,
        name,
        date,
        totalAmount,
        logo,
      }) => ({
        title: name,
        date,
        amount: totalAmount,
        logo,
        onClick() {
          router.push(`/investments/${id}`);
        },
      }));
      return orderBy(result, 'date', 'desc');
    },
  },

  created() {
    this.fetchData();
  },

  methods: mapActions('investment', {
    fetchData: 'fetchList',
  }),
};
</script>
